import axios from 'axios';

// API Base URL Configuration
// Change this to switch between Node.js and PHP backend

// For PHP Backend (XAMPP)
// export const API_BASE_URL = 'http://localhost/php-backend';

// For Node.js Backend (Local)
// export const API_BASE_URL = 'http://localhost:5001/api';

// For Production (Shared Hosting) - Hostinger
export const API_BASE_URL = 'https://clinic.medxarena.com';

// Set axios default base URL
axios.defaults.baseURL = API_BASE_URL;

// Set default headers
axios.defaults.headers.common['Content-Type'] = 'application/json';

// Disable preflight for simple requests
axios.defaults.headers.post['Content-Type'] = 'application/json';

// Add token to requests
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default axios;
